import { FormattedMessage } from "react-intl";

function SafeFormattedMessage({ msgKey, messagesData }) {
  const msg = messagesData && messagesData[msgKey];
  const valid = msg && typeof msg.id === "string" && msg.id.length > 0;
  if (valid) {
    return <FormattedMessage {...msg} />;
  }
  return <span>{msgKey || ""}</span>;
}

export default function AllPersonalityTraitsPages({
  messagesData,
  graph,
  code,
  datePassed,
  keyPage,
  pageNumber
}) {
  function renderAllTraitDetailsList({
    index,
    liClassName = "list-counter-marker",
    pageNumber = 1
  }) {
    const allTraits = Array.isArray(graph?.dataTitles)
      ? graph.dataTitles
      : Object.values(graph?.dataTitles || {});

    return allTraits.flatMap((trait, idx) => {
      if (!trait || idx !== index) return [];

      trait = typeof trait === "string"
        ? trait.replace("SCOPEREPORT_", "")
        : trait;

      trait = typeof trait === "string"
        ? trait.replace("EXCITEMENTSEEK", "EXCITEMENT_SEEKING")
        : trait;

      // For each trait, return two list items: one for LOWERTHIRD, one for UPPERTHIRD
      return ["LOWERTHIRD", "UPPERTHIRD"].map(extremeKey => {
        const prefix = `SCOPE_REPORT_${trait.toUpperCase().replace(/ /g, "_")}`;
        let percentilePrefix = `${prefix}_PERCENTILE_100`;
        let percentileTitle = `${prefix}_PERCENTILE_100_TITLE`;
        let getDetails = `${prefix}_AXIS_HIGH_DESC`;
        let managerDetails = false;

        if (extremeKey === "LOWERTHIRD") {
          percentilePrefix = `${prefix}_PERCENTILE_25`;
          percentileTitle = `${prefix}_PERCENTILE_25_TITLE`;
          getDetails = `${prefix}_AXIS_LOW_DESC`;
        }

        if (pageNumber === 5 || pageNumber === 6) {
          const traitKey = trait.toUpperCase().replace(/ /g, "_");
          if (extremeKey === "LOWERTHIRD") {
            getDetails = `SCOPE_REPORT_${traitKey}_DESC_LOW`;
            managerDetails = `SCOPE_REPORT_${traitKey}_MANAGER_DESC_LOW`;
          } else {
            getDetails = `SCOPE_REPORT_${traitKey}_DESC`;
            managerDetails = `SCOPE_REPORT_${traitKey}_MANAGER_DESC`;
          }
        }

        let traitDetails;
        if (pageNumber === 6 || pageNumber === 5) {
          traitDetails = {
            title: `${prefix}${extremeKey === "LOWERTHIRD" ? "_AXIS_LOW" : "_AXIS_HIGH"}`,
            description: `${prefix}_DESC`,
            percentile: `${percentileTitle}`,
            strengthsIntro: `${percentilePrefix}_STRENGTHS_INTRO`,
            strengths1: `${percentilePrefix}_STRENGTHS_1`,
            strengths2: `${percentilePrefix}_STRENGTHS_2`,
            strengths3: `${percentilePrefix}_STRENGTHS_3`,
            developmentIntro: `${percentilePrefix}_DEVELOPMENT_INTRO`,
            development1: `${percentilePrefix}_DEVELOPMENT_1`,
            development2: `${percentilePrefix}_DEVELOPMENT_2`,
            development3: `${percentilePrefix}_DEVELOPMENT_3`,
            teamAdvice: `${percentilePrefix}_TEAM_ADVICE`,
            collaboration: `${percentilePrefix}_COLLABORATION`,
            management: `${percentilePrefix}_MANAGEMENT`,
            recognition: `${percentilePrefix}_RECOGNITION`,
            teamKnow: `${percentilePrefix}_TEAM_KNOW`,
            teamKnowLabel: `SCOPE_REPORT_TEAM_KNOW_LABEL`,
            teamAdviceLabel: `SCOPE_REPORT_TEAM_ADVICE_LABEL`,
          };
        } else {
          traitDetails = {
            title: `${prefix}${extremeKey === "LOWERTHIRD" ? "_AXIS_LOW" : "_AXIS_HIGH"}`,
            description: `${prefix}_DESC`,
            percentile: `${percentilePrefix}_TITLE`,
            strengthsIntro: `${percentilePrefix}_STRENGTHS_INTRO`,
            strengths1: `${percentilePrefix}_STRENGTHS_1`,
            strengths2: `${percentilePrefix}_STRENGTHS_2`,
            strengths3: `${percentilePrefix}_STRENGTHS_3`,
            developmentIntro: `${percentilePrefix}_DEVELOPMENT_INTRO`,
            development1: `${percentilePrefix}_DEVELOPMENT_1`,
            development2: `${percentilePrefix}_DEVELOPMENT_2`,
            development3: `${percentilePrefix}_DEVELOPMENT_3`,
            optimize4me: `SCOPE_REPORT_OPTIMIZE_FOR_ME_LABEL`,
            leversMotivation: `SCOPE_REPORT_LEVERS_OF_MOTIVATION_LABEL`,
            optimize: `${percentilePrefix}_OPTIMIZE`,
            motivation: `${percentilePrefix}_MOTIVATION`,
            teamAdvice: `${percentilePrefix}_TEAM_ADVICE`,
            teamAdviceLabel: `SCOPE_REPORT_TEAM_ADVICE_LABEL`,
          };
        }

        return (
          <li key={idx + "_" + extremeKey + "_traits"} className={liClassName}>
            <b className="font-18">
              <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.title} />
            </b>{" "}
            (<SafeFormattedMessage messagesData={messagesData} msgKey={extremeKey} />)
            <span className="trait-details-box">
              <br />
              <SafeFormattedMessage messagesData={messagesData} msgKey={getDetails} />
              <br />
              {(pageNumber === 5 || pageNumber === 6) && managerDetails && (
                <div className="trait-details-list-box">
                  <b>
                    <SafeFormattedMessage messagesData={messagesData} msgKey={'SCOPE_REPORT_MANAGER_SUMMARY_LABEL'} />
                  </b>{" "}
                  <SafeFormattedMessage messagesData={messagesData} msgKey={managerDetails} />
                </div>
              )}
              <span className="trait-details-list-box">
                <span>
                  <span>
                    <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.strengthsIntro} />
                  </span>
                  <ul className="trait-strengths-list" style={{ margin: 0, paddingLeft: 24 }}>
                    {[traitDetails.strengths1, traitDetails.strengths2, traitDetails.strengths3].map((key, idx) => {
                      if (!key || messagesData[key]?.id === undefined) return null;
                      return (
                        <li className="trait-strengths-list-item" key={idx}>
                          <SafeFormattedMessage messagesData={messagesData} msgKey={key} />
                        </li>
                      );
                    })}
                  </ul>
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <span>
                    <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.developmentIntro} />
                  </span>
                  <ul className="trait-development-list" style={{ margin: 0, paddingLeft: 24 }}>
                    {[traitDetails.development1, traitDetails.development2, traitDetails.development3].map((key, idx) => {
                      if (!key || messagesData[key]?.id === undefined) return null;
                      return (
                        <li className="trait-development-list-item" key={idx}>
                          <SafeFormattedMessage messagesData={messagesData} msgKey={key} />
                        </li>
                      );
                    })}
                  </ul>
                </span>
              </span>
              {pageNumber !== 6 && (
                <span className="trait-details-list-box">
                  <span>
                    <b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.optimize4me} />
                    </b>
                    <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.optimize} />
                  </span>
                </span>
              )}
              {pageNumber !== 6 && (
                <span className="trait-details-list-box">
                  <span>
                    <b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.leversMotivation} />
                    </b>
                    <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.motivation} />
                  </span>
                </span>
              )}
              {pageNumber === 1 && (
                <span className="trait-details-list-box">
                  <span>
                    <b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamAdviceLabel} />
                    </b>
                    <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamAdvice} />
                  </span>
                </span>
              )}
              {pageNumber === 5 && (
                <>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={"SCOPE_REPORT_COLLABORATION_LABEL"} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.collaboration} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={"SCOPE_REPORT_MANAGEMENT_LABEL"} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.management} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={"SCOPE_REPORT_RECOGNITION_LABEL"} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.recognition} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamAdviceLabel} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamAdvice} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamKnowLabel} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamKnow} />
                    </span>
                  </span>
                </>
              )}
              {pageNumber === 6 && (
                <>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamAdviceLabel} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamAdvice} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={"SCOPE_REPORT_COLLABORATION_LABEL"} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.collaboration} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={"SCOPE_REPORT_MANAGEMENT_LABEL"} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.management} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={"SCOPE_REPORT_RECOGNITION_LABEL"} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.recognition} />
                    </span>
                  </span>
                  <span className="trait-details-list-box">
                    <span>
                      <b>
                        <SafeFormattedMessage messagesData={messagesData} msgKey={"SCOPE_REPORT_ESSENTIAL_FOR_ME_LABEL"} />
                      </b>
                      <SafeFormattedMessage messagesData={messagesData} msgKey={traitDetails.teamKnow} />
                    </span>
                  </span>
                </>
              )}
            </span>
          </li>
        );
      });
    });
  }

  // Render trait pages (one trait per page, numbered accordingly)
  return (
    <>
      {[0,1,2,3,4,5,6,7].map((traitIdx) => (
        <div className="PageCharts-chart" key={traitIdx}>
          <div className="header-logo-box"></div>
          <div className="report-alt-page">
            <h1>
              <SafeFormattedMessage messagesData={messagesData} msgKey={graph.title} />
              <span className="inline font-16">
                {" "} -{" "}
                <SafeFormattedMessage messagesData={messagesData} msgKey="SCOPE_REPORT_TOP_THREE" />
              </span>
            </h1>
            <ol className="list-counter" start={traitIdx * 2 + 1}>
              {renderAllTraitDetailsList({
                index: traitIdx,
                pageNumber
              })}
            </ol>
          </div>
          <div className="pdf-footer">
            <SafeFormattedMessage messagesData={messagesData} msgKey="PAGE" />{" "}
            {keyPage + traitIdx + 2}
            <div className="pdf-footer-separator">
              <b>
                <SafeFormattedMessage messagesData={messagesData} msgKey="CANDIDATE" />
              </b>
            </div>{" "}
            {code}
            <div className="pdf-footer-separator">
              <b>
                <SafeFormattedMessage messagesData={messagesData} msgKey="TEST_DATE" />
              </b>{" "}
              {datePassed}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}